import React from 'react'

const AdminChefDocuments = () => {
    return (
        <h2>Chef Docuements</h2>
    )
}

export default AdminChefDocuments
